/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 */
import Icon from './Icon';
export default Icon;
export { IconColor } from './IconColor';
export { IconType } from './IconType';